import { Component, OnInit, ViewEncapsulation, OnDestroy, ViewChild, ElementRef } from '@angular/core';

import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DialogService } from 'primeng/dynamicdialog';

import { Subscription } from 'rxjs';

import { DataService, HTTPService, HelperService, CalculationService } from 'app/services';
import { config, messages } from 'app/constants';
import { CancelApptDialogComponent } from '../cancel-appt-dialog/cancel-appt-dialog.component';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { TireRecommendedSizeComponent } from '../../estimate/components/vehicle-specific-lookup-dialog/components/tire-size-different-recommended-dialog/tire-size-different-recommended-dialog.component';
import { CustomerAddComponent } from '../customer-add/customer-add.component';
@Component({
  selector: 'app-add-dialog',
  templateUrl: './add-dialog.component.html',
  styleUrls: ['./add-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService],
})
export class AddDialogComponent implements OnInit, OnDestroy {
  public subscription: Subscription;
  deleteApptDialog: any = null;
  previousContext;
  customerContext = 'add-customer';
  vehicleContext = 'add-vehicle';
  appointmentContext = 'add-appointment';

  customerForVehicle;
  customerForAppointment;
  estimateForAppointment;

  submit: any;
  isSubmitVisible: boolean = true;
  customerNameForCreate: any;
  customerPhoneForCreate: any;
  customerEmailForCreate: any;
  vehicleNameForCreate: string = '';
  isMarketingNotifEnabled: boolean = true;
  isOperationalNotifEnabled: boolean = true;

  appointmentInputVisible: boolean = true;
  appointmentColors: any[] = [];
  qboTaxExemptReasons: any[] = [];
  company: any = {};
  appointment = {
    _id: null,
    title: null,
    color: config.defaultColor,
    date: {
      start: null,
      end: null,
    },
    time: {
      start: null,
      end: null,
    },
    type: 'internal',
    appointmentData: null,
    resourceId: '',
    status: '',
    props: [],
    isOpenBlockTab: false,
    preferredLanguage: 'en',
  };
  saveButtonText = 'Save';
  heading;
  from;
  tab;
  active;
  dataServiceSub: Subscription = null;
  isProcessing: boolean = false;
  customerType: string = 'customer';
  isOpenFromCreateCustomer = false;
  hideAppointmentTitle = false;
  showColorDropdown = true;
  isCreateMode: boolean = false;
  cart: any;
  onlineOrderSource: string = '';
  proceed: any;
  vehicleOnCart: any = {};
  isQTQAddOnEnable: boolean = false;
  adonServices: any = {};
  cartOutTheDoor: any = {};
  selectedTax: any = {};
  currentCustomerLang: string = 'en';

  @ViewChild('submitBtn') submitBtn!: ElementRef<HTMLButtonElement>;
  @ViewChild(CustomerAddComponent) customerAddComponent!: CustomerAddComponent;


  constructor(
    public ref: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private httpService: HTTPService,
    private helperService: HelperService,
    public dataService: DataService,
    private calculationService: CalculationService
  ) { }

  ngOnInit() {
    this.isQTQAddOnEnable = this.dataService.isQTQAddOnEnable;
    const data = this.dConfig.data;
    this.tab = data.tab;
    if (data.data && data.data.data && data.data.data.isOpenFromCreateCustomer) {
      this.isOpenFromCreateCustomer = data.data.data.isOpenFromCreateCustomer;
    }

    if (data && data.tab && data.tab === 'add-customer') {
      if (data.from === 'estimate') {
        this.customerNameForCreate = data.data.fullName;
      }

      this.heading = 'Create new customer';
      this.from = data.from;
      this.active = 'add-customer';
    } else if (data && data.tab && data.tab === 'add-vehicle') {
      this.heading = 'Create new vehicle';
      this.from = data.from;

      if (this.from === 'quick-tire-lookup') {
        this.heading = 'Add customer and vehicle';
        //this.cart = data.data?.cartDetails;
        //this.onlineOrderSource = data.data?.source;
        this.vehicleOnCart = data.data?.vehicleOnCart;
        if (this.isQTQAddOnEnable) {
          this.adonServices = data.data?.adonServices;
          this.cartOutTheDoor = data.data?.cartOutTheDoor;
          this.cart = data.data?.cart;
          this.onlineOrderSource = data.data?.onlineOrderSource;
          this.selectedTax = data.data?.selectedTax;
        } else {
          this.cart = data.data?.cartDetails;
          this.onlineOrderSource = data.data?.source;
        }
      } else {
        this.customerForVehicle = data.data;
        this.vehicleNameForCreate = data.data?.vehicleName;
      }

      this.active = 'add-vehicle';
    } else if (data && data.tab && data.tab === 'add-part') {
      this.heading = 'create new part';
      this.from = data.from;
      this.active = 'add-part';
    } else if (data && data.tab && data.tab === 'add-appointment') {
      this.heading = 'Create new appointment';
      this.from = data.from;
      this.saveButtonText = 'Save';

      // Set type for delete appointment conformation;
      if (data.data && data.data.type) {
        this.appointment.type = data.data.type;
      }

      if (this.from === 'estimate') {
        this.estimateForAppointment = data.data;
        this.appointment.title = data.data.title;
      } else if (['upcoming-appointment', 'add-vehicle'].includes(this.from)) {
        if (data.data) {
          this.appointment.title = `${data.data.fullName}`;
          this.customerForAppointment = data.data;
          this.appointment.preferredLanguage = data.data.preferredLanguage;
          this.customerForAppointment.appointment = this.appointment;
        }
      } else {
        if (data.data && data.data.vehicle && data.data.vehicle._id) {
          this.customerForAppointment = data.data;
        }

        if (data.data && data.data._id) {
          this.appointment._id = data.data._id;
          this.appointment.title = data.data.title;
          this.appointment.color = data.data.color;
          this.appointment.status = data.data.status;
          this.appointment.appointmentData = data.data;
          this.appointment.preferredLanguage = data.data.preferredLanguage;
        }

        if (data.data && data.data.startDate && data.data.endDate) {
          this.appointment.date.start = data.data.startDate;
          this.appointment.date.end = data.data.endDate;
        }

        if (data.data && data.data.startTime && data.data.endTime) {
          this.appointment.time.start = data.data.startTime;
          this.appointment.time.end = data.data.endTime;
        }
      }
      this.appointment.resourceId = data.data && data.data.resourceId;
      this.appointment.props = data.data && data.data.props;
      this.appointment.isOpenBlockTab = data.data && data.data.isOpenBlockTab;

      if (data.data && data.data.code && data.data.appointment) {
        this.showColorDropdown = false;
        this.appointment._id = data.data.appointment.appointmentId;
      }

      if (data.data && data.data.props && data.data.props.type === 'block') {
        this.hideAppointmentTitle = true;
      }

      this.active = 'add-appointment';
    }

    /**
     * This subscribe is called from the following
     * - appointment-add.component
     */
    this.dataServiceSub = this.dataService.getData().subscribe((obj) => {
      const data = obj.data;

      if (data.type === 'passdata' && data.key === 'appointment-color') {
        this.appointment.color = data.data;
      }

      if (data.type === 'passdata' && data.key === 'appointment-title') {
        this.appointment.title = data.data;
      }

      if (data.type === 'passdata' && data.key === 'removeCustomer') {
        this.refreshCalender();
      }
    });

    this.setCompanyData(this.dataService.company);
    this.setTaxExemptReasons();
  }

  setAppointmentColors = (color: any[]) => {
    this.appointmentColors = color;
  };

  setTaxExemptReasons = (qboTaxExemptReasons = []) => {
    if (qboTaxExemptReasons.length > 0) {
      this.qboTaxExemptReasons = qboTaxExemptReasons;
    }
    else {
      this.httpService.getQboTaxExemptReasons().then(response => {
        this.qboTaxExemptReasons = response.reasons;
      });
    }
  };

  setProcessingState = (state: boolean) => {
    this.isProcessing = state;
  };

  setCurrentCustomerLang = (event: any) => {
    this.currentCustomerLang = event;
  };

  setCustomerType = (customerType: string) => {
    if (customerType === 'fleet') {
      this.heading = this.heading.replace('customer', 'fleet');
    } else {
      this.heading = this.heading.replace('fleet', 'customer');
    }

    this.customerType = customerType;
  };

  setCompanyData = (company: any) => {
    // console.log('setCompanyData', this.helperService.deepCopy(company));
    this.company = this.helperService.deepCopy(company);
  };

  appointmentDeleteBtn() {
    if (this.appointment.type === 'external') {
      if (this.appointment.status === 'cancelled') {
        this.deleteAppointment({ _id: this.appointment._id }).then(
          (appt) => {
            if (appt.appointmentRequests) {
              this.deleteAppointmentRequest();
            } else {
              this.refreshCalender();
            }
            this.close();
            if (appt.customer && appt.customer.customerId) {
              this.dataService.sendData(
                this.dataService.typeDialog('estimate', 'appointment', appt.customer && appt.customer.customerId, appt.customer && appt.customer.fullName, { appointment: appt }),
              );
            }
            this.dataService.sendData(this.dataService.typeUpdate('delete-appointment', 'delete-appointment'));
            this.helperService.showToaster('success', 'Event Deleted');
          },
          (err) => {
            this.helperService.showToaster('error', err);
          },
        );
      } else {
        this.openConfirmCancelApptDialog();
      }
    } else {
      const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
        width: '30%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          styleClassHeading: 'font-14',
          title: 'Delete this appointment?',
          message: 'This action cannot be undone',
          button: {
            success: { title: 'Confirm' },
            cancel: { title: 'Cancel' },
          },
        },
      });

      const onClose = ref.onClose.subscribe((close: any) => {
        if (close.isSuccess) {
          this.onDontSendNotification(this.appointment);
        }

        onClose.unsubscribe();
      });
    }
  }

  openConfirmCancelApptDialog(header?, data?: any) {
    const { appointmentData } = this.appointment;
    const { companyName, companyPhone } = this.helperService.getCompany();
    const customer = appointmentData && appointmentData.customer;
    const ref = this.dialogService.open(CancelApptDialogComponent, {
      header: header,
      width: '500px',
      styleClass: 'small-heading-dialog',
      data: {
        _id: appointmentData._id,
        companyName,
        companyPhone,
        startDate: this.helperService.getDate(appointmentData.startDateTime),
        customer,
        isSMS: appointmentData.isSMS,
        isEmail: appointmentData.isEmail,
        refetch: true,
        currentLang: this.currentCustomerLang
      },
      showHeader: false,
    });

    const onClose = ref.onClose.subscribe((data) => {
      if (data.type === 'dontsend') {
        this.onDontSendNotification(data.data);
      }

      if (data.type === 'send') {
        this.onSendNotification(data.data);
      }

      onClose.unsubscribe();
    });
  }

  /** make http call to delete the appointment */
  deleteAppointment(data) {
    return this.httpService.deleteAppointment(data);
  }

  /** hit the data service in calender-view to refresh the calender inorder to remove the deleted appt */
  refreshCalender() {
    this.dataService.sendData(this.dataService.typeUpdate('calendar-view', 'calendar'));
  }

  deleteAppointmentRequest() {
    this.dataService.sendData(this.dataService.typeUpdate('delete-request', 'delete-request'));
  }

  /** Delete the Appt without sending any notification */
  onDontSendNotification(data) {
    this.deleteAppointment({
      _id: data._id,
    }).then(
      (appt) => {
        if (appt.appointmentRequests) {
          this.deleteAppointmentRequest();
        } else {
          this.refreshCalender();
        }
        this.close();

        if (appt.customer && appt.customer.customerId) {
          this.dataService.sendData(
            this.dataService.typeDialog('estimate', 'appointment', appt.customer && appt.customer.customerId, appt.customer && appt.customer.fullName, { appointment: appt, appointmentDelete: true }),
          );
        }
        this.helperService.showToaster('success', messages.appointmentDelete);
        this.dataService.sendData(this.dataService.typeUpdate('delete-appointment', 'delete-appointment'));
      },
      (err) => {
        this.helperService.showToaster('error', err.message);
      },
    );
  }

  /** Delete the Appt and send the notification */
  onSendNotification(data) {
    this.deleteAppointment({
      _id: data._id,
      isEmail: data.isEmail,
      isSMS: data.isSMS,
      customer: data.customer,
      confirmationText: data.content,
    }).then(
      (appt) => {
        if (appt.appointmentRequests) {
          this.deleteAppointmentRequest();
        } else {
          this.refreshCalender();
        }
        this.refreshCalender();
        this.close();

        if (appt.customer && appt.customer.customerId) {
          this.dataService.sendData(this.dataService.typeDialog('estimate', 'appointment', appt.customer && appt.customer.customerId, appt.customer && appt.customer.fullName, { appointment: appt }));
        }
        this.dataService.sendData(this.dataService.typeUpdate('delete-appointment', 'delete-appointment'));
        this.helperService.showToaster('error', messages.appointmentDelete);
      },
      (err) => {
        this.helperService.showToaster('error', err.message);
      },
    );
  }

  close(isSuccess: boolean = false, data: any = null) {
    if (this.from === 'quick-tire-lookup' && this.isCreateMode) {
      this.isCreateMode = false;
      return;
    }
    this.active = '';
    this.isCreateMode = false;
    this.customerForVehicle = null;
    this.customerForAppointment = null;
    this.ref.close({ isSuccess, data });
    this.dataService.sendData(this.dataService.typePassData('modal-closed', {}));
    localStorage.removeItem('startTimePersisted');
    localStorage.removeItem('endTimePersisted');

  }

  customerCreated(event: any) {
    this.saveButtonText = 'Save';
    this.ref.close({
      _id: event.customer._id,
      fullName: event.customer.fullName,
      email: event.customer.email,
      phone: event.customer.phone,
      customer: event.customer.customer,
      openFrom: event.openFrom,
      from: this.from,
      tab: 'add-customer',
    });
  }

  closeCancelApptDialog() {
    this.deleteApptDialog.close();
  }

  vehicleCreated(event) {
    this.saveButtonText = 'Save';
    if (event.openFrom === 'add-appointment') {
      this.customerForAppointment = {
        isCreatedForOther: true,
        _id: event.customer._id,
        vehicle: {
          _id: event.vehicle._id,
          name: event.vehicle.name,
          ...event.vehicle,
        },
      };
      this.active = event.openFrom;
      this.isSubmitVisible = true;
    } else {
      this.ref.close({
        _id: event.customer._id,
        fullName: event.customer.fullName,
        vehicle: event.vehicle,
        openFrom: event.openFrom,
        from: this.from,
        tab: 'add-vehicle',
        updateVehicleFlag: event.updateVehicleFlag || false,
      });
    }
  }

  appointmentCreated(event) {
    this.dataService.sendData(this.dataService.typePassData('modal-closed', {}));
    this.ref.close({
      _id: event.customer._id,
      fullName: event.customer.fullName,
      openFrom: event.openFrom,
      navigateToEstimate: event.navigateToEstimate,
      tab: 'add-appointment',
      type: event.type,
      vehicle: event.vehicle,
      data: event && event.updateObj,
    });
  }

  changeSubmitBtnId(event = '') {
    const valid = this.customerAddComponent.validation(event)
    if(valid){
    this.submitBtn.nativeElement.id = 'btn-save-create';
    }else{
      this.submitBtn.nativeElement.id = 'btn-save';
    }
  }
  createCustomerFromOther(event: any) {
    this.customerNameForCreate = event.fullName;
    this.customerPhoneForCreate = event.phoneNumber;
    this.customerEmailForCreate = event.email;
    this.customerContext = event.context;
    this.previousContext = event.context;
    this.active = 'add-customer';
    this.isSubmitVisible = false;
    this.saveButtonText = 'Save';
    this.isMarketingNotifEnabled = event.isMarketingNotifEnabled;
    this.isOperationalNotifEnabled = event.isOperationalNotifEnabled;
  }

  createVehicleFromOther(event: any) {
    this.customerForVehicle = {
      _id: event.appointment.customer.customerId,
      fullName: `${event.appointment.customer.fullNameQBO}`,
      fullNameQBO: `${event.appointment.customer.fullNameQBO}`,
      isFleetCustomer: event.appointment.customer.isFleetCustomer,
      companyName: `${event.appointment.customer.companyName}`,
      displayName: `${event.appointment.customer.fullNameQBO}`,
      phone2: `${event.appointment.customer.phone2}`,
      notes: `${event.appointment.customer.notes}`,
      phone: `${event.appointment.customer.phone}`,
      email: `${event.appointment.customer.email}`,
      contactOnPhone: event.appointment.customer.contactOnPhone,
      contactOnEmail: event.appointment.customer.contactOnEmail,
      vehicles: event.appointment.vehicles,
      vehicleNameForCreate: event.vehicleName,
    };
    this.vehicleNameForCreate = event.vehicleName;
    this.vehicleContext = event.openFrom;
    this.previousContext = event.openFrom;
    this.active = 'add-vehicle';
    this.isSubmitVisible = false;
    this.saveButtonText = 'Save';
  }

  customerCreatedForOther(event: any) {
    if (event.openFrom === 'add-vehicle') {
      this.customerForVehicle = {
        _id: event.customer._id,
        fullName: event.customer.fullNameQBO,
        fullNameQBO: event.customer.fullNameQBO,
      };
    } else if (event.openFrom === 'add-appointment') {
      this.customerForAppointment = {
        _id: event.customer._id,
      };
    }
    this.saveButtonText = 'Save';
    this.active = event.openFrom;
  }

  vehicleCreatedForOther(event: any) {
    this.customerForAppointment = {
      isCreatedForOther: true,
      ...event.customer,
      vehicle: {
        _id: event.vehicle._id,
        name: event.vehicle.name,
        ...event.vehicle,
      },
    };
    this.active = event.openFrom;
    this.isSubmitVisible = true;
    this.saveButtonText = 'Save';
  }

  back(type: string) {
    this.saveButtonText = 'Save';

    if (this.from === 'quick-tire-lookup' && this.isCreateMode) {
      this.isCreateMode = false;
      return;
    }

    if (this.previousContext === 'add-vehicle' && type === 'vehicle') {
      this.cancelCreatedForOther({ openFrom: 'add-appointment', type });
    } else {
      this.cancelCreatedForOther({ openFrom: this.previousContext, type });
    }
  }

  cancelCreatedForOther(event: any) {
    if (event.openFrom === 'add-vehicle') {
      this.active = 'add-vehicle';
      this.saveButtonText = 'Create vehicle';
    } else if (event.openFrom === 'add-customer') {
      this.active = 'add-customer';
      this.saveButtonText = 'Save';
    }
    else {
      this.close()
    }

    /**
     * This data is subscribe in the following
     * - appointment-add.component
     * - vehicle-add.component
     */
    this.dataService.sendData(this.dataService.typePassData('clear-search-data', true));
  }

  onFocusATInput() {
    this.appointmentInputVisible = true;
  }

  onBlurATInput() {
    if (this.appointment.title !== null && this.appointment.title !== '') {
      this.appointmentInputVisible = false;
    }
  }

  saveColorChange(data) {
    console.log(data);
    this.dataService.sendData(this.dataService.typePassData('refresh-after-color-update', {}));
  }

  onTitleChange(title) {
    /**
     * This data is subscribe in appointment-add.component
     */
    this.dataService.sendData(this.dataService.typePassData('appointment-title', title));
  }

  onColorChange(color: any) {
    this.appointment.color = color;
    /**
     * This data is subscribe in appointment-add.component
     */
    this.dataService.sendData(this.dataService.typePassData('appointment-color', color));
  }

  onSubmit() {
    this.submit = {
      active: this.active,
      data: null,
    };
    this.customerForVehicle = {};
  }

  openTaxDifferenceConfirmationDialog(data: any, messageBody: string) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: 'We are noticing a tax difference',
        message: messageBody,
        button: {
          success: { title: 'Confirm' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }: any) => {
      if (isSuccess) {
        this.onProceedQuickTireLookup(data, true);
      }

      onClose.unsubscribe();
    });
  }

  onProceedQuickTireLookup(event: any, isFromConfirmation: boolean = false) {
    if (event && event.data && event.data.payload) {
      const obj = event.data;
      let openRecomendedTireModal: boolean = true;
      let cartSizes: any[] = [];
      let recSizes: any[] = [];
      if (this.isQTQAddOnEnable) {
        if (!isFromConfirmation) {
          if (event?.customerInfo.taxExempt) {
            let message: string = `The selected customer has a sales tax override (Exempt - 0%) that differs from the sales tax used for quoting (${this.selectedTax?.name}).`;
            this.openTaxDifferenceConfirmationDialog(event, message);
            return;
          } else if (event?.customerInfo?.isFleetCustomer && event?.customerInfo?.isTaxCodeOverride && event?.customerInfo?.customTaxCode?._id !== this.selectedTax.id) {
            let message: string = `The selected customer has a sales tax override (${event?.customerInfo?.customTaxCode?.name} - ${event?.customerInfo?.customTaxCode?.salesTaxRate}%) that differs from the sales tax used for quoting (${this.selectedTax?.name}).`;
            this.openTaxDifferenceConfirmationDialog(event, message);
            return;
          } else if (
            event?.data?.estimateId &&
            event?.data?.estimateId !== 'new-ro' &&
            event?.customerInfo?.selecteEstimateTax?.name &&
            this.selectedTax.id !== event?.customerInfo?.selecteEstimateTax?.id
          ) {
            let message: string = `The selected RO has a sales tax (${event?.customerInfo?.selecteEstimateTax?.name}) that differs from the sales tax used for quoting (${this.selectedTax?.name}).`;
            this.openTaxDifferenceConfirmationDialog(event, message);
            return;
          }
        }

        const sources: any = Object.keys(this.cart) || [];
        if (sources?.length) {
          sources.forEach((source: string) => {
            if (source === 'tireconnect') {
              if (this.cart[source]?.items?.length) {
                cartSizes = [
                  ...cartSizes,
                  ...this.cart[source]?.items?.map((item: any) => {
                    return this.helperService.tireSizeParser(item?.size || '');
                  }),
                ];
              }
            } else {
              if (this.cart[source]?.length) {
                cartSizes = [
                  ...cartSizes,
                  ...this.cart[source].map((item: any) => {
                    return this.helperService.tireSizeParser(item?.size || '');
                  }),
                ];
              }
            }
          });
        }
      } else {
        if (this.onlineOrderSource === 'TireConnect') {
          if (this.cart && this.cart.items?.length) {
            cartSizes = this.cart.items.map((item: any) => {
              return this.helperService.tireSizeParser(item?.size || '');
            });
          }
        } else {
          cartSizes = this.cart.map((item: any) => {
            return this.helperService.tireSizeParser(item?.size || '');
          });
        }
      }

      if (obj.recommendedSizes && obj.recommendedSizes?.length) {
        recSizes = obj.recommendedSizes.map((size: string) => {
          return this.helperService.tireSizeParser(size);
        });
      }
      const repairObjectObj: any = {
        customer: {
          customerId: obj.payload.customerId,
          // isFleetCustomer: event?.customerInfo?.isFleetCustomer,
          // isTaxCodeOverride: event?.customerInfo?.isTaxCodeOverride,
          // taxExempt: event?.customerInfo?.taxExempt,
        },
        vehicle: obj.payload,
        onlineOrderSource: this.onlineOrderSource,
        cart: this.cart,
      };

      if (this.isQTQAddOnEnable) {
        repairObjectObj.hasTireConnectCart = this.onlineOrderSource.includes('tireconnect');
        repairObjectObj.hasTireHubCart = this.onlineOrderSource.includes('tirehub');
        repairObjectObj.hasAlInventoryCart = this.onlineOrderSource.includes('autoleap');
        repairObjectObj.adonServices = this.adonServices;
        repairObjectObj.cartOutTheDoor = this.cartOutTheDoor;
        this.applyFleetCustomerPricingMatrixOverride(repairObjectObj.adonServices, event.customerInfo);
      }

      if (obj.estimateId) {
        repairObjectObj.estimateId = obj.estimateId;
      }
      if (recSizes && recSizes?.length && cartSizes && cartSizes?.length) {
        cartSizes.forEach((cartSize: any) => {
          recSizes.forEach((recSize: any) => {
            if (cartSize.tireSizeSearch === recSize.tireSizeSearch) {
              openRecomendedTireModal = false;
            }
          });
        });

        if (openRecomendedTireModal) {
          const ref = this.dialogService.open(TireRecommendedSizeComponent, {
            width: '550px',
            styleClass: `add-dialog recommended-tire-size-differ-dialog`,
            showHeader: false,
            data: {
              cartSizes: cartSizes,
              recommendedSizes: recSizes,
            },
          });

          const onClose = ref.onClose.subscribe(({ isSuccess }) => {
            if (isSuccess) {
              this.ref.close({ isSuccess: true, data: repairObjectObj });
            }
            onClose.unsubscribe();
          });
        } else {
          this.ref.close({ isSuccess: true, data: repairObjectObj });
        }
      } else {
        this.ref.close({ isSuccess: true, data: repairObjectObj });
      }
    }
  }

  applyFleetCustomerPricingMatrixOverride(payloadAdonServices: any, customerInfo: any) {
    if(customerInfo?.isFleetCustomer && payloadAdonServices?.items?.length) {
      const { isLaborRateOverride, isPricingMatrixOverride, customLaborRate, customPartPricingMatrix } = customerInfo;
      payloadAdonServices?.items?.forEach((item: any) => {
        if (item.type === 'labor' && isLaborRateOverride && customLaborRate) {
          item.billRate = customLaborRate && customLaborRate.rate;
          item.price = item.billRate * item.billableHours;
          item.pricing = { pricingId: customLaborRate.pricingId, name: customLaborRate.name };
        }

        if (['part', 'tire'].includes(item.type)) {

          if(isPricingMatrixOverride && customPartPricingMatrix){
            item.pricing = { pricingId: customPartPricingMatrix.pricingId, name: customPartPricingMatrix.name };
            item.price = this.calculationService.calculateMarkUpUsingPricing(item.cost, customPartPricingMatrix);
          }
        }
      });

    }
  }

  isSameVehicle() { }

  onProceed() {
    this.proceed = {
      active: this.active,
      data: null,
    };
    this.customerForVehicle = {};
    //this.openTireRecommendedSizeDialog();
    //this.ref.close({isSuccess: true});
  }

  openTireRecommendedSizeDialog(cartSize: string[]) { }

  ngOnDestroy() {
    if (this.dataServiceSub) {
      this.dataServiceSub.unsubscribe();
    }
  }
}
